module.exports = __webpack_public_path__ + "static/media/career-adviser-dashboard.72213c5b.jpg";